import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { LanguageProvider } from "@/context/LanguageContext";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";

import LandingPage from "@/pages/LandingPage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import CustomerLayout from "@/components/layouts/CustomerLayout";
import AdminLayout from "@/components/layouts/AdminLayout";
import Dashboard from "@/pages/customer/Dashboard";
import ApiKeys from "@/pages/customer/ApiKeys";
import Analytics from "@/pages/customer/Analytics";
import Billing from "@/pages/customer/Billing";
import ApiDocs from "@/pages/customer/ApiDocs";
import Help from "@/pages/customer/Help";
import HelpManage from "@/pages/admin/HelpManage";
import Settings from "@/pages/customer/Settings";
import TwoFactorSettings from "@/pages/customer/TwoFactorSettings";
import SystemOverview from "@/pages/admin/SystemOverview";
import DeviceManagement from "@/pages/admin/DeviceManagement";
import TenantManagement from "@/pages/admin/TenantManagement";
import AuditLogs from "@/pages/admin/AuditLogs";
import Alerts from "@/pages/admin/Alerts";
import TenantOnboard from "@/pages/admin/TenantOnboard";
import TenantDetail from "@/pages/admin/TenantDetail";
import TenantUsage from "@/pages/admin/TenantUsage";
import TenantKeys from "@/pages/admin/TenantKeys";
import WidgetBuilder from "@/pages/admin/WidgetBuilder";
import RoleManagement from "@/pages/admin/RoleManagement";
import TranslationManagement from "@/pages/admin/TranslationManagement";
import ReportBuilder from "@/pages/admin/ReportBuilder";
import DataArchival from "@/pages/admin/DataArchival";
import LiveDashboard from "@/pages/admin/LiveDashboard";
import PlanManagement from "@/pages/admin/PlanManagement";
import EmailConfiguration from "@/pages/admin/EmailConfiguration";
import NotFound from "@/pages/NotFound";

function App() {
  return (
    <LanguageProvider>
      <AuthProvider>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route path="/" element={<LandingPage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />

              {/* Customer Portal — requires authentication */}
              <Route path="/dashboard" element={
                <ProtectedRoute>
                  <CustomerLayout />
                </ProtectedRoute>
              }>
                <Route index element={<Dashboard />} />
                <Route path="api-keys" element={<ApiKeys />} />
                <Route path="analytics" element={<Analytics />} />
                <Route path="billing" element={<Billing />} />
                <Route path="api-docs" element={<ApiDocs />} />
                <Route path="settings" element={<Settings />} />
                <Route path="security" element={<TwoFactorSettings />} />
                <Route path="help" element={<Help />} />
              </Route>

              {/* Admin Portal — requires super_admin or admin role */}
              <Route path="/admin" element={
                <ProtectedRoute allowedRoles={["super_admin", "admin"]}>
                  <AdminLayout />
                </ProtectedRoute>
              }>
                <Route index element={<SystemOverview />} />
                <Route path="devices" element={<DeviceManagement />} />
                <Route path="tenants" element={<TenantManagement />} />
                <Route path="tenants/new" element={<TenantOnboard />} />
                <Route path="tenants/:tenantId" element={<TenantDetail />} />
                <Route path="tenants/:tenantId/usage" element={<TenantUsage />} />
                <Route path="tenants/:tenantId/keys" element={<TenantKeys />} />
                <Route path="audit-logs" element={<AuditLogs />} />
                <Route path="alerts" element={<Alerts />} />
                <Route path="widgets" element={<WidgetBuilder />} />
                <Route path="dashboard" element={<LiveDashboard />} />
                <Route path="roles" element={<RoleManagement />} />
                <Route path="plans" element={<PlanManagement />} />
                <Route path="translations" element={<TranslationManagement />} />
                <Route path="reports" element={<ReportBuilder />} />
                <Route path="data-archival" element={<DataArchival />} />
                <Route path="email-config" element={<EmailConfiguration />} />
                <Route path="help" element={<HelpManage />} />
              </Route>

              <Route path="*" element={<NotFound />} />
            </Routes>
          </BrowserRouter>
          <Toaster position="top-right" />
        </div>
      </AuthProvider>
    </LanguageProvider>
  );
}

export default App;
